export const normalizeRegistrationEmail = (value) => String(value || '').trim().toLowerCase();

export const validateRegistrationEmail = (value) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizeRegistrationEmail(value))
    ? ''
    : 'Veuillez saisir une adresse e-mail valide.';

export const validateRegistrationPassword = (password = '') => {
  if (password.length < 8) return 'Le mot de passe doit contenir au moins 8 caractères.';
  if (!/[A-Z]/.test(password) || !/[a-z]/.test(password) || !/\d/.test(password) || !/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    return 'Ajoutez une majuscule, une minuscule, un chiffre et un caractère spécial au mot de passe.';
  }
  return '';
};

export const registrationErrorMessage = (error) => {
  const code = `${error?.code || ''} ${error?.message || ''}`.toUpperCase().replace(/-/g, '_');
  if (code.includes('INVALID_EMAIL')) return 'Veuillez saisir une adresse e-mail valide.';
  if (code.includes('EMAIL_EXISTS') || code.includes('EMAIL_ALREADY_IN_USE')) return 'Cette adresse e-mail est déjà utilisée. Connectez-vous ou utilisez une autre adresse.';
  if (code.includes('WEAK_PASSWORD')) return 'Veuillez choisir un mot de passe plus robuste.';
  if (code.includes('TOO_MANY')) return 'Trop de tentatives. Veuillez réessayer plus tard.';
  return 'Impossible de créer votre compte. Veuillez réessayer.';
};
